import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_Zoom from 'ol/control/Zoom';
import { Util } from '../util';
import Map from '../map';

export class Zoom extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            duration: undefined,
            className: undefined,
            zoomInLabel: undefined,
            zoomOutLabel: undefined,
            zoomInTipLabel: undefined,
            zoomOutTipLabel: undefined,
            delta: undefined
        };
        this.events = {
            'change': undefined,
            'propertychange': undefined
        };
    }
    render() {
        return null;
    }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_Zoom(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
Zoom['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};